import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOrder, setText } from '../../features/filter/filterSlice';
import { getJobs } from '../../features/jobs/jobsSlice';
import JobSingleRow from './JobSingleRow';

const MainCompo = () => {
    const { jobs, loading } = useSelector(state => state.jobs)
    const { type, text, order } = useSelector(state => state.filter)

    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(getJobs(type))
    }, [type, dispatch])

    const handleTextChange = e => {
        dispatch(setText(e.target.value))
    }
    const handleOrderChange = e => {
        dispatch(setOrder(e.target.value))
        console.log(e.target.value, 'd')
    }

    const filterData = useMemo(() => {
        let data = [...jobs];
        if (text) {
            data = jobs.filter(single => single.title.toLowerCase().includes(text.toLowerCase()))
        }
        if (order) {
            if (order === 'lth') {
                data = data.sort((a, b) => parseFloat(a.salary) - parseFloat(b.salary))
            }
            else {
                data = data.sort((a, b) => parseFloat(b.salary) - parseFloat(a.salary))

            }
        }
        return data;
    }, [jobs, text, order])
    return (
        <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
            <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
                <h1 className="lws-section-title">{type || "All Available "} Jobs</h1>
                <div className="flex gap-4">
                    <div className="search-field group flex-1">
                        <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
                        <input onChange={handleTextChange} type="text" placeholder="Search Job" className="search-input" id="lws-searchJob" />
                    </div>
                    <select value={order} onChange={handleOrderChange} id="lws-sort" name="sort" autocomplete="sort" className="flex-1">
                        <option value=''>Default</option>
                        <option value='lth'>Salary (Low to High)</option>
                        <option value='htl'>Salary (High to Low)</option>
                    </select>
                </div>
            </div>

            <div className="jobs-list">
                {/* <!-- Single Job 1--> */}
                {
                    loading ?
                        <div className='text-center'>Loading</div>
                        :
                        filterData.length ?
                            filterData.map(single => <JobSingleRow key={single.id} {...single}></JobSingleRow>)
                            : <div className='text-center'>No Data Found</div>
                }

                {/* <!-- Single Job 1--> */}
            </div>
        </main>
    );
};

export default MainCompo;